// extracted by mini-css-extract-plugin
export default {"DashBoard":"AfterLogin_DashBoard__i8U2d"};